export type CustomErrorType = {
  response: {
    data: {
      message: string
    }
  }
}

export const isCustomError = (error: unknown): error is CustomErrorType => {
  return !!(error as CustomErrorType).response?.data?.message
}
